import { render, staticRenderFns } from "./PTour.vue?vue&type=template&id=12e8e62f&"
import script from "./PTour.vue?vue&type=script&lang=js&"
export * from "./PTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports